import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

function truncateText(text, maxLength) {
  if (text.length <= maxLength) {
    return text;
  } else {
    return text.substring(0, maxLength - 3) + '...';
  }
}



function ServiceCard({
    icon,
    heading,
    content,
    btnText="Learn More",
    btnRef="/"
}) {
  const cardRef = useRef()
  const [boxHeight,setBoxHeight] = useState("180px")
    const navigate= useNavigate()
    const para = truncateText(content,100)

    useEffect(()=>{
      const recalcHeight = ()=>{
        setBoxHeight(`${cardRef.current?.offsetWidth}px`)
      }

      recalcHeight()

      window.addEventListener("resize", recalcHeight);
      return () => window.removeEventListener("resize", recalcHeight);
    },[])
  return (
    <div className="service-card d-flex flex-column justify-content-end" ref={cardRef} style={{backgroundImage:`url(${icon})`,height:boxHeight}} onClick={()=>{navigate(btnRef)}}>

          <h3 className='body-heading-w mt-1 color-light  mb-0 px-4 text-center py-2 d-flex align-items-center justify-content-center' style={{fontSize:"15px",borderBottomLeftRadius:'20px',borderBottomRightRadius:"20px"}}>{heading}</h3>
      
</div>
  )
}
export function ServiceCard2({
    icon,
    heading,
    content,
    btnText="Learn More",
    btnRef="/"
}) {
    const navigate= useNavigate()
    const para = truncateText(content,100)
  return (
    <div className="service-card py-4">
    <div className="service-card-info">
      
      <div className="profile-info px-3 d-flex flex-column gap-3 text-start ">
        
        {/* <div className='icon-container'>

        </div> */}
          <img src={icon} alt="" className='icon'/>
          <h3 className='body-heading-w mt-1 color-light' style={{fontSize:"20px"}}>{heading}</h3>
          <p className="review-text body-paragraph ">{para}</p>
          {/* <button className='genral-btn' onClick={()=>{navigate(btnRef)}}>{btnText}</button> */}
      </div>
     
    </div>
</div>
  )
}

export default ServiceCard